import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> { 
        if (this.authService.isLoggedIn()) {
                const token = this.authService.getAuthorizationToken();
                request = request.clone({
                    setHeaders:
                        { Authorization: token }
                }
            );
        }
        return next.handle(request);
    }
}